<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4" jhiTranslate="modals.addOrUpdateMerchandise.titleCreate"></p>
  </div>
  <form>
    <div class="modal-body text-left" *ngIf="controls">
      <div class="alert alert-info" jhiTranslate="modals.addOrUpdateMerchandise.alert"></div>
      <div class="col-12">
        <jhi-bary-title titleKey="modals.addOrUpdateMerchandise.subTitle"></jhi-bary-title>
      </div>
      <div class="col-12">
        <jhi-bary-input-text [control]="controls.newItemsNature" [label]="'modals.addOrUpdateMerchandise.name' | translate"></jhi-bary-input-text>
      </div>
      <div class="col-12">
        <jhi-bary-input-switch [onLabel]="'sur devis'" *ngIf="controls.quotationRequired.value" (onChangeEvent)="changeActif($event)" [value]="true"></jhi-bary-input-switch>
        <jhi-bary-input-switch [onLabel]="'sur devis'" *ngIf="!controls.quotationRequired.value" (onChangeEvent)="changeActif($event)" [value]="false"></jhi-bary-input-switch>
      </div>
      <div class="col-12 mt-4">
        <jhi-bary-input-multi-select
          [tooltip]="'modals.addOrUpdateMerchandise.offerTooltip' | translate"
          [placeholder]="'modals.addOrUpdateMerchandise.offerPlaceholder' | translate"
          [label]="'modals.addOrUpdateMerchandise.offerLabel' | translate"
          [title]="'modals.addOrUpdateMerchandise.offerTitle' | translate"
          [control]="controls.offers"
          [options]="options"
        ></jhi-bary-input-multi-select>
      </div>
    </div>
    <div class="modal-footer justify-content-end">
      <div class="mr-3">
        <jhi-bary-button [outline]="true" color="primary" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ first: true })"></jhi-bary-button>
      </div>
      <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'BTN.ADD' | translate" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
